<template>
  <!-- Header Area -->

  <header id="header" class="header-area">
    <div class="sticky-area">
      <div class="navigation">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-3 col-12">
              <div class="logo">
                <a class="navbar-brand" href="#"
                  ><img src="/assets/img/wmk-logo-white.png" alt="Logo WMK"
                /></a>
              </div>
            </div>

            <div class="col-lg-6 col-12">
              <div class="main-menu">
                <nav class="navbar navbar-expand-lg">
                  <div class="collapse navbar-collapse justify-content-center"
                    id="navbarSupportedContent">
                    <ul class="navbar-nav m-auto">
                      <li class="nav-item">
                        <a class="nav-link" href="#"
                          >Strona Główna
                          <span class="sub-nav-toggler"> </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" href="#about"
                        >Więcej informacji
                          <span class="sub-nav-toggler"> </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" href="#service"
                          >Zakres działalności
                          <span class="sub-nav-toggler"> </span>
                        </a>
                      </li>

                      <li class="nav-item">
                        <a class="nav-link" href="#contact"
                          >Kontakt
                          <span class="sub-nav-toggler"> </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
            <div class="col-lg-3 col-12">
              <div class="logo-pibr">
                <a class="navbar-brand" href="https://www.pibr.org.pl/pl/auditor/show/280"
                  ><img src="/assets/img/pibr-logo.png" alt="Logo PIBR"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  mounted() {
    //jQuery Sticky Area
    $(".sticky-area").sticky({
      topSpacing: 0,
    });

    // Mobile Menu
    $(".navbar-toggler").on("click", function () {
      $(this).toggleClass("active");
    });

    $(".navbar-nav li a").on("click", function () {
      $(".sub-nav-toggler").removeClass("active");
    });

    var subMenu = $(".navbar-nav  .sub-menu");
    if (subMenu.length) {
      subMenu
        .parent("li")
        .children("a")
        .append(function () {
          return '<button class="sub-nav-toggler"> <i class="las la-angle-down"></i> </button>';
        });

      var subMenuToggler = $(".navbar-nav .sub-nav-toggler");

      subMenuToggler.on("click", function () {
        $(this).parent().parent().children(".sub-menu").slideToggle();
        return false;
      });
    }

    // Menu Active Color

    $(".main-menu .navbar-nav .nav-link").on("mouseover", function () {
      $(".main-menu .navbar-nav .nav-link").removeClass("active");
      $(this).addClass("active");
    });
  },
  setup() {},
};
</script>
